import OrderItem from './OrderItem';

export default OrderItem;
